import { useEffect, useState } from "react";
import { Menu, X, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";
import { HOME } from "@/constants/testIds";
import Logo from "@/components/Logo";

const links = [
  { href: "#atletes-xiv", label: "Atletes XIV", id: "nav-link-atletes-xiv" },
  { href: "#resultats", label: "Resultats", id: "nav-link-resultats" },
  { href: "#classificacio", label: "Palmarès", id: "nav-link-palmares" },
  { href: "#info", label: "Info", id: "nav-link-info" },
  { href: "#contacte", label: "Contacte", id: HOME.navLinkContacte },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      data-testid={HOME.nav}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F7F1E8]/95 backdrop-blur-md border-b border-[#15140F]/10 py-3"
          : "bg-[#0E1410]/30 backdrop-blur-sm py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between gap-4">
        <a
          href="#hero"
          data-testid={HOME.navLogo}
          className="flex items-center group shrink-0"
        >
          <Logo size="sm" onDark={!scrolled} />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className={`px-4 py-2 text-sm font-display uppercase tracking-wider transition-colors ${
                scrolled ? "text-[#15140F] hover:text-[#E94E1B]" : "text-white hover:text-[#F2B23A]"
              }`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/atletes"
            data-testid="nav-link-atletes"
            className={`px-4 py-2 text-sm font-display uppercase tracking-wider transition-colors inline-flex items-center gap-1.5 ${
              scrolled ? "text-[#15140F] hover:text-[#E94E1B]" : "text-white hover:text-[#F2B23A]"
            }`}
          >
            <Newspaper size={14} /> Atletes
          </Link>
          <a
            data-testid={HOME.navCtaInscribe}
            href="#resultats"
            className="ml-3 px-5 py-2.5 bg-[#E94E1B] text-white font-display uppercase tracking-wider text-sm hover:bg-[#C03A12] transition-colors"
          >
            Resultats
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden p-2 ${scrolled ? "text-[#15140F]" : "text-white"}`}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#0E1410] border-t border-[#F7F1E8]/10 px-5 py-6">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white font-display uppercase tracking-wider py-3 border-b border-white/10"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/atletes"
              onClick={() => setOpen(false)}
              className="text-[#F2B23A] font-display uppercase tracking-wider py-3 border-b border-white/10 inline-flex items-center gap-2"
            >
              <Newspaper size={14} /> Espai atletes
            </Link>
            <a
              href="#resultats"
              className="mt-4 px-5 py-3 bg-[#E94E1B] text-white text-center font-display uppercase tracking-wider"
            >
              Veure resultats
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
